"use strict";
/*
* Created on 14.06.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Wrapper object used in product placement logic and for creating window item placement collection.
 *
 * @author ZSr
 */


var ProductPlacementCount =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ProductPlacementCount, _DomainObject_1$Domai);

  /**
   * @param placementTypeId internal id from placement type codebook
   * @param secondaryPlacement external placement type id
   * @param windowItemId internal id of window item
   * @param siteIds internal id of a site
   */
  function ProductPlacementCount(placementTypeId, secondaryPlacement, windowItemId, siteIds) {
    var _this;

    _classCallCheck(this, ProductPlacementCount);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductPlacementCount).call(this));
    _this.placementTypeId = placementTypeId;
    _this.secondaryPlacement = secondaryPlacement;
    _this.windowItemId = windowItemId;
    _this.siteIds = siteIds;
    return _this;
  }

  return ProductPlacementCount;
}(DomainObject_1.DomainObject);

exports.ProductPlacementCount = ProductPlacementCount;